import { Button,Tooltip } from "@material-ui/core";
// import {ToggleButton,Autocomplete} from "@material-ui/lab";
import React from "react";
import "./index.css";
import firebase from "../firebase.js";
import { useEffect } from "react";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import {
  // occupiedTopics,
  fetchSubjects,
  // updateOccupiedTopics,
  occupiedPapers,
  // updateSubjects,
} from "./topics";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllTopics,
  getCompletedPapers,
  getOccupiedTopics,
  setAllTopics,
  setOccupiedTopics,
  setCompletedPapers,
} from "./../../features/Questions/questionSlice";
import { getEmail, getName } from "../../features/userSlice";

function Dashboard() {
  const [phyPapers, setphyPapers] = useState([]);
  const [chemPapers, setchemPapers] = useState([]);
  const [mathPapers, setmathPapers] = useState([]);
  const [fullPapers, setfullPapers] = useState([]);
  const occupiedFilter = useSelector(getOccupiedTopics) || [];
  const userName = useSelector(getName);
  // const [searchItem, setsearchItem] = useState("");
  // const freeTopics = ["FULL Paper 1"];
  const jeeTopics = useSelector(getAllTopics) || [];
  let history = useHistory();
  const completedPapers = useSelector(getCompletedPapers) || [] ;
  const dispatch = useDispatch();
  // const user = useSelector(getEmail);
  const getfetchedSubjects = async () => {
    if (!jeeTopics.length) {
      // console.log("fetching all topics...");
      const fetchedTopics = await fetchSubjects();
      if (!fetchedTopics) history.push("/errorPage");
      else dispatch(setAllTopics(fetchedTopics));
    }
  };
  // let loader = 0;
  const getOccupiedPapers = async () => {
    if (!occupiedFilter.length) {
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          occupiedPapers(user.email).then((data) => {
            dispatch(setOccupiedTopics(data.occupiedPapers));
            dispatch(setCompletedPapers(data.Answers));
          });
          // console.log("fetched..")
        } 
      });
    }
  };

  useEffect(() => {
    getfetchedSubjects();
  }, []);
  
  useEffect(() => {
    getOccupiedPapers();
  }, [userName]);
  // loader = jeeTopics.length;
  useEffect(() => {
    for (let i = 0; i < jeeTopics.length; i++) {
      if (jeeTopics[i].startsWith("FULL"))
        setfullPapers((arr) => [...arr, jeeTopics[i]]);
      else if (jeeTopics[i].startsWith("PHY"))
        setphyPapers((arr) => [...arr, jeeTopics[i]]);
      else if (jeeTopics[i].startsWith("CHEM"))
        setchemPapers((arr) => [...arr, jeeTopics[i]]);
      else if (jeeTopics[i].startsWith("MATH"))
        setmathPapers((arr) => [...arr, jeeTopics[i]]);
    }
  }, [jeeTopics]);

  // useEffect(() => {
  // document.getElementById(searchItem)
  // }, [searchItem])

  function topic(q) {
    const handleClick = (e) => {
      e.preventDefault();
      console.log(e.target.offsetParent.id);

      let name = e.target.offsetParent.id;
     const user = firebase.auth().currentUser;
        if (user) {
          history.push("/testPage/" + btoa(name))
            // : history.push("/Purchase/" + btoa(name));
        }else{
          window.alert("Login To Continue");
        }
      // });
      // e.target.getAttribute("data-index");
      return;
    };
    // console.log(freeTopics,freeTopics.indexOf(q),q);
    // console.log(completedPapers);
    let text = "OPEN"
    if (q.slice(5) === "Coming Soon...") text = "NA"
    else if (completedPapers.indexOf(q) >= 0) text = "RETAKE"
    return (
      <>
        {
          <div
            className={`topic col mb-3 p-3 ${
              ""
              // occupiedFilter && occupiedTopics.indexOf(q) == -1 && "d-none"
            } `}
            key={q}
            id={q}
          >
            <h5
              className="text-truncate"
              data-toggle="tooltip"
              title={q.slice(4)}
            >
              {q.slice(4)}
            </h5>
            {/* {freeTopics.indexOf(q) >= 0 && (
              <svg
                // xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 469.333 469.333"
                width="43"
                // class="_2lD-FxGmv_YEIZr5Rmd3Wb"
              >
                <g fill="#D80027">
                  <path d="M451.125 222.708L250.292 21.875C236.396 7.979 217.167 0 197.5 0H42.667C19.146 0 0 19.135 0 42.667V197.49c0 19.938 7.771 38.688 21.875 52.802l200.833 200.833c11.75 11.74 27.375 18.208 43.958 18.208s32.208-6.469 43.958-18.208l140.5-140.5c11.75-11.729 18.208-27.344 18.208-43.958s-6.457-32.23-18.207-43.959zm-15.083 72.834l-140.5 140.5c-15.458 15.417-42.292 15.417-57.75 0L36.958 235.208c-10.083-10.083-15.625-23.479-15.625-37.719V42.667c0-11.76 9.563-21.333 21.333-21.333H197.5c14.042 0 27.792 5.698 37.708 15.625l200.833 200.833C443.75 245.5 448 255.75 448 266.667c0 10.916-4.25 21.166-11.958 28.875z"></path>
                  <path d="M251.271 266.354a10.632 10.632 0 007.542 3.125c2.729 0 5.458-1.042 7.542-3.125 4.167-4.167 4.167-10.917 0-15.083l-15.087-15.087 15.087-15.09 22.625 22.635c4.167 4.167 10.917 4.167 15.083 0 4.167-4.167 4.167-10.917 0-15.083l-30.167-30.177c-2-2-4.708-3.125-7.542-3.125s-5.542 1.125-7.542 3.125l-60.333 60.344c-4.167 4.167-4.167 10.917 0 15.083l30.167 30.167a10.634 10.634 0 007.542 3.125c2.729 0 5.458-1.042 7.542-3.125 4.167-4.167 4.167-10.917 0-15.083l-22.625-22.625 15.082-15.085 15.084 15.084zM334.229 258.812c-4.167-4.167-10.917-4.167-15.083 0l-60.333 60.333c-4.167 4.167-4.167 10.917 0 15.083l30.167 30.177a10.634 10.634 0 007.542 3.125c2.729 0 5.458-1.042 7.542-3.125 4.167-4.167 4.167-10.917 0-15.083l-22.625-22.635 15.083-15.083 15.083 15.083c2.083 2.083 4.813 3.125 7.542 3.125s5.458-1.042 7.542-3.125c4.167-4.167 4.167-10.917 0-15.083l-15.083-15.083 15.083-15.083 22.625 22.625c4.167 4.167 10.917 4.167 15.083 0 4.167-4.167 4.167-10.917 0-15.083l-30.168-30.168zM145.667 145.677c4.167-4.167 4.167-10.917 0-15.083l-15.083-15.091 15.083-15.086 22.625 22.625c4.167 4.167 10.917 4.167 15.083 0 4.167-4.167 4.167-10.917 0-15.083l-30.167-30.167c-4-4-11.083-4-15.083 0l-30.151 30.156s-.01.005-.016.01c-.005.005-.005.01-.005.01l-30.161 30.167c-4.167 4.167-4.167 10.917 0 15.083a10.634 10.634 0 007.542 3.125c2.729 0 5.458-1.042 7.542-3.125l22.626-22.63 15.082 15.089a10.634 10.634 0 007.542 3.125c2.728 0 5.457-1.042 7.541-3.125zM207.771 207.792c7.896-.417 15.25-3.698 20.875-9.323 12.479-12.479 12.479-32.771 0-45.25l-15.083-15.083c-4.167-4.167-10.917-4.167-15.083 0l-29.896 29.885c-.104.094-.208.188-.292.281a2.387 2.387 0 00-.271.292l-29.896 29.875c-4.167 4.167-4.167 10.917 0 15.083 4.167 4.167 10.917 4.167 15.083 0l22.625-22.625 7.563 7.531c4.146 4.167 4.146 10.938 0 15.094l-15.104 15.094c-4.167 4.156-4.167 10.917 0 15.083a10.634 10.634 0 007.542 3.125c2.729 0 5.458-1.042 7.542-3.125l15.104-15.094c5.77-5.781 8.874-13.25 9.291-20.843zm-1.75-47.032l7.542 7.542c4.167 4.156 4.167 10.927 0 15.083-2.021 2.01-4.688 3.125-7.542 3.125H206a10.53 10.53 0 01-7.521-3.135l-7.542-7.531 15.084-15.084z"></path>
                </g>
              </svg>
            )} */}
            {completedPapers.indexOf(q) >= 0 && (
              <Tooltip title="Check Result">
                <DoneAllIcon
                  fontSize="large"
                  style={{ cursor: "pointer" }}
                  onClick={() => history.push("/result/" + btoa(q))}
                ></DoneAllIcon>
              </Tooltip>
            )}
            <Button
              key={q}
              id={q}
              disabled={q.slice(5) === "Coming Soon..."}
              data-index={q}
              variant="contained"
              color="primary"
              onClick={handleClick}
            >
              { text} 
            </Button>
          </div>
        }
      </>
    );
  }

const Loader = () =>{
  return <div class="lds-hourglass"></div>;
}

  return (
    <div className="dashboard">
      <div className="store">
        <h1 style={{ color: "#626ee3" }} className="text-center p-3">
          EXPLORE PAPERS
        </h1>
        <div className="d-flex">
          {/* <Autocomplete
              id="combo-box-demo"
              options={jeeTopics.map((e) => {
                return e.slice(4);
              })}
              getOptionLabel={(option) => option}
              onChange={(event) => setsearchItem(event.target.innerHTML)}
              style={{ width: 230, margin: 10 }}
              renderInput={(params) => (
              <TextField
                {...params}
                label="Search Topics"
                variant="outlined"
              />
            )}
          />
          <Checkbox
            value="check"
            style={{ margin: 10 }}
            selected={occupiedFilter}
              inputProps={{ "aria-label": "secondary checkbox" }}
              onChange={() => {
                // setoccupiedFilter(occupiedFilter);
                console.log(occupiedFilter);
              }}
            >
              <label>
                <i className="bi bi-check"></i>{" "}
              </label>
            </Checkbox> */}
        </div>
        {jeeTopics.length ? (
          <div className="subject d-flex justify-content-around flex-wrap">
            <div className="all sub">
              <h3 className="text-center p-3 ">ALL</h3>
              <br />
              {fullPapers.map(topic)}
            </div>
            <div className="phy sub">
              <h3 className="text-center p-3"> PHYSICS</h3>
              <br />
              {phyPapers.map(topic)}
            </div>
            <div className="chem sub">
              <h3 className="text-center p-3">CHEMISTRY</h3>
              <br />
              {chemPapers.map(topic)}
            </div>
            <div className="math sub">
              <h3 className="text-center p-3">MATHS</h3>
              <br />
              {mathPapers.map(topic)}
            </div>{" "}
          </div>
        ) : (
          <Loader />
        )}
      </div>
      {/* <Loader/> */}

      {/* <Button
        onClick={async () => {
          // console.log(user);
          // OccupiedTopics(user.email, ["FULL Paper 2", "FULL Paper 3"]);
          // updateSubjects(["FULL Paper 6"])
        }}
      >
        Update Topics Of your email
      </Button> */}
    </div>
  );
}

export default Dashboard;
